
const CookiePolicy = () => {
  return (
    <div className="min-h-screen py-20">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="glass-card p-8 md:p-12 rounded-3xl">
            <h1 className="text-4xl md:text-5xl font-lora font-bold gradient-text mb-8">
              Politika piškotkov
            </h1>
            
            <div className="prose prose-invert prose-lg max-w-none">
              <p className="text-white/80 text-lg leading-relaxed mb-8">
                Zadnja posodobitev: 1. januar 2024
              </p>

              <section className="mb-8">
                <h2 className="text-2xl font-lora font-semibold text-white mb-4">1. Kaj so piškotki?</h2>
                <p className="text-white/80 leading-relaxed mb-4">
                  Piškotki (cookies) so majhne besedilne datoteke, ki se shranijo na vašo napravo 
                  (računalnik, telefon, tablica), ko obiščete spletno stran. Omogočajo nam, da se 
                  spletna stran "spomni" vaših dejanj in nastavitev.
                </p>
                <p className="text-white/80 leading-relaxed">
                  Piškotki sami po sebi ne vsebujejo osebnih podatkov, lahko pa jih povezujejo z 
                  informacijami, ki jih imate shranjene pri nas.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-lora font-semibold text-white mb-4">2. Katere piškotke uporabljamo?</h2>
                
                <div className="space-y-6">
                  <div className="glass-card p-6 rounded-xl">
                    <h3 className="text-xl font-medium text-white mb-3">2.1 Nujno potrebni piškotki</h3>
                    <p className="text-white/80 leading-relaxed mb-3">
                      Ti piškotki so potrebni za osnovno delovanje spletne strani in jih ne morete izklopiti.
                    </p>
                    <ul className="list-disc pl-6 space-y-1 text-white/70">
                      <li>Piškotki za sejo (session cookies)</li>
                      <li>Piškotki za varnost</li>
                      <li>Piškotki za shranjevanje vaših nastavitev</li>
                    </ul>
                  </div>

                  <div className="glass-card p-6 rounded-xl">
                    <h3 className="text-xl font-medium text-white mb-3">2.2 Analitični piškotki</h3>
                    <p className="text-white/80 leading-relaxed mb-3">
                      Ti piškotki nam pomagajo razumeti, kako obiskovalci uporabljajo našo spletno stran.
                    </p>
                    <ul className="list-disc pl-6 space-y-1 text-white/70">
                      <li>Google Analytics (anonimni podatki o obiskih)</li>
                      <li>Podatki o strani, ki jih obiskovalci najpogosteje obišče</li>
                      <li>Čas, preživet na strani</li>
                    </ul>
                  </div>

                  <div className="glass-card p-6 rounded-xl">
                    <h3 className="text-xl font-medium text-white mb-3">2.3 Funkcionalni piškotki</h3>
                    <p className="text-white/80 leading-relaxed mb-3">
                      Ti piškotki izboljšujejo funkcionalnost in personalizacijo spletne strani.
                    </p>
                    <ul className="list-disc pl-6 space-y-1 text-white/70">
                      <li>Jezikovne nastavitve</li>
                      <li>Shranjevanje vašega soglasja za piškotke</li>
                      <li>Nastavitve prikaza</li>
                    </ul>
                  </div>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-lora font-semibold text-white mb-4">3. Piškotki tretjih oseb</h2>
                <p className="text-white/80 leading-relaxed mb-4">
                  Nekateri piškotki prihajajo od zunanjih storitev, ki jih uporabljamo na naši strani:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-white/80">
                  <li><strong>Google Analytics:</strong> Za analizo prometa (anonimno)</li>
                  <li><strong>Google Fonts:</strong> Za nalaganje pisav</li>
                  <li><strong>Družbeni mediji:</strong> Če delite vsebino (Instagram, Facebook)</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-lora font-semibold text-white mb-4">4. Upravljanje piškotkov</h2>
                <div className="text-white/80 leading-relaxed space-y-4">
                  <h3 className="text-xl font-medium text-white">4.1 V brskalniku</h3>
                  <p>
                    Piškotke lahko upravljate neposredno v nastavitvah vašega brskalnika. 
                    Tam lahko piškotke blokirate, izbrišete ali nastavite obvestila.
                  </p>
                  
                  <h3 className="text-xl font-medium text-white">4.2 Naše nastavitve</h3>
                  <p>
                    Pri prvem obisku naše strani lahko izberete, katere piškotke želite dovoliti. 
                    Svoje odločitve lahko kadarkoli spremenite.
                  </p>
                  
                  <div className="glass-card p-4 rounded-xl mt-4">
                    <p className="text-white/90">
                      <strong>Opomba:</strong> Če blokirate vse piškotke, lahko to vpliva na delovanje spletne strani.
                    </p>
                  </div>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-lora font-semibold text-white mb-4">5. Vodilni brskalniki</h2>
                <p className="text-white/80 leading-relaxed mb-4">
                  Navodila za upravljanje piškotkov v različnih brskalnikih:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-white/80">
                  <li><strong>Google Chrome:</strong> Nastavitve → Napredne → Zasebnost in varnost → Piškotki</li>
                  <li><strong>Firefox:</strong> Nastavitve → Zasebnost in varnost → Piškotki in podatki strani</li>
                  <li><strong>Safari:</strong> Nastavitve → Zasebnost → Piškotki in podatki spletnih strani</li>
                  <li><strong>Edge:</strong> Nastavitve → Piškotki in dovoljenja strani</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-lora font-semibold text-white mb-4">6. Kako dolgo shranjujemo piškotke?</h2>
                <div className="text-white/80 leading-relaxed space-y-4">
                  <ul className="list-disc pl-6 space-y-2">
                    <li><strong>Sejmni piškotki:</strong> Se izbrišejo, ko zaprete brskalnik</li>
                    <li><strong>Trajni piškotki:</strong> Ostanejo do 2 leti ali dokler jih ne izbrišete</li>
                    <li><strong>Analitični piškotki:</strong> Se shranijo do 26 mesecev</li>
                  </ul>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-lora font-semibold text-white mb-4">7. Spremembe politike</h2>
                <p className="text-white/80 leading-relaxed">
                  Pridržujemo si pravico do spremembe te politike piškotkov. O pomembnejših 
                  spremembah vas bomo obvestili na naši spletni strani.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-lora font-semibold text-white mb-4">8. Kontakt</h2>
                <p className="text-white/80 leading-relaxed mb-4">
                  Če imate vprašanja o piškotkih, nas kontaktirajte:
                </p>
                <div className="glass-card p-4 rounded-xl">
                  <p className="text-white/90">
                    <strong>E-pošta:</strong> alma.lovrencic@gmail.com<br />
                    <strong>Telefon:</strong> +386 51 479 667
                  </p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;